import src from "./bg-mobile.jpg";
export default { src: src, aspect: 1.5127272727272727, width: 1248, height: 825 };